import { defineComponent as _defineComponent } from 'vue'
import { computed, ref} from "vue";

// props
interface IProps {
	value?: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterWallet',
  props: {
    value: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	value?: any;
};



// computed
const isInvalid = computed<boolean>(() => wallet.value.trim() === "");

// data
const wallet = ref<string>(props.value ?? "");

// expose
expose({ isInvalid });

return { __sfc: true,props, isInvalid, wallet }
}

})